import { Component, OnInit } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { NotificationsService } from "angular2-notifications";
import { EduClass } from "src/app/models/edu-class";
import { DefaultApiService } from "src/app/shared/services/default-api.service";

@Component({
  selector: "app-enter-creche-remarks",
  templateUrl: "./enter-creche-remarks.component.html",
  styleUrls: ["./enter-creche-remarks.component.css"],
})
export class EnterCrecheRemarksComponent implements OnInit {
  loading = true;
  classes: EduClass[] = [];
  classStudents;
  selectedStudent;
  abilities = [];
  subjects;
  remarkForm: FormGroup;
  classSelectorGroup: FormGroup;
  basicData;
  modal;
  selectedClass = new FormControl("");
  abilitiesLocal = [
    "Ability to recorgnize 1-20",
    "Ability to write A-z",
    "Ability to recite A-z",
    "Ability to recorgnize A-Z",
    "Ability to scribe/write",
    "Ability to express himself/herself in simple sentence",
    "Ability to identify simple colours",
    "Ability to say and act on ryhmes",
    "Ability to participate in music and dance, drama and cultural activities",
    "Ability to identify basic needs",
    "Ability to identify basic shapes",
  ];

  constructor(
    private defaultApi: DefaultApiService,
    private fb: FormBuilder,
    private notificationService: NotificationsService
  ) {}

  ngOnInit() {
    this.getBasicData();
    this.remarkForm = this.fb.group({
      abilitiesArray: this.fb.array(
        this.abilitiesLocal.map((ability) => this.createAbilityGroup(ability))
      ),
      teacherRemark: [""],
    });
    this.getClasses();
   
  }

  createAbilityGroup(ability: string): FormGroup {
    return this.fb.group({
      ability: [ability],
      frequency: ["", Validators.required], // always/sometimes/never
      subject: ["", Validators.required],
      marks: ["", [Validators.required, Validators.pattern("^[0-9]+$")]],
    });
  }

  get abilitiesArray(): FormArray {
    return this.remarkForm.get("abilitiesArray") as FormArray;
  }

  onClassSelected(event: Event) {
    event.preventDefault();

    const selectedClassId = (event.target as HTMLSelectElement).value;
    this.getStudentInClass(selectedClassId);
  }

  getClasses() {
    this.loading = true;
    const url = "api/v1/classes";
    this.defaultApi.getAll(url).subscribe(
      (response) => {
        console.log(response);
        this.classes = response.data.classes;
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        console.log(error);
      }
    );
  }

  getStudentInClass(studentClassId: string) {
    console.log('studentClassId', studentClassId)
    const url = "";
    this.classStudents = this.classes.filter((classes: any) => {
          return classes.id == studentClassId;
        })[0].students;
  }

  getAbilities() {
    const url = "api/v1/creche-abilities";
    this.loading = true;
    this.defaultApi.getAll(url).subscribe(
      (response: any) => {
        this.loading = false;

        this.abilities = response.map((ability: any) => {
          return ability.name;
        });

        console.log("abilities from api", this.abilities);
      },
      (error) => {
        this.loading = false;
        // this.errorService.handleError(error);
      }
    ); // This method can be used to fetch user abilities or permissions if neede
  }

  getBasicData() {
    this.defaultApi.getAll("api/v1/enter-class-marks/get-basic-data").subscribe(
      (response: any) => {

        this.basicData = response.data;

        this.classes = response.data.classes;

        this.classStudents = response.data.classes.filter((classes: any) => {
          return classes.name.toLowerCase().includes("creche");
        })[0].students;

        // console.log(this.classStudents);

        this.subjects = response.data.subjects;
        // console.log("subjects", this.subjects);

        this.loading = false;
      },
      (error) => {
        this.loading = false;
        console.error("Error fetching basic data:", error);
        // Handle the error appropriately, e.g., show a notification or log it
      }
    );
  }

  onRefresh() {}

  enterRemarkModal(modal: any, student: any) {
    modal.show();
    this.modal = modal;
    // Logic to open a modal for entering remarks for the student
    console.log("Open modal for student:", student);
    this.selectedStudent = student;
    // You can implement the modal logic here, e.g., using a dialog service
  }

  onSubmitForm(event: Event) {
    event.preventDefault(); // Prevent default form submission

    this.loading = true;
    this.defaultApi
      .save(
        {
          data: {
            basic_data: this.basicData,
            formRes: this.remarkForm.value,
            student: this.selectedStudent,
          },
        },
        "api/v1/student-abilities-remarks"
      )
      .subscribe(
        (response: any) => {
          console.log("Form submitted successfully:", response);
          this.loading = false;
          this.notificationService.success("success", "Entries Saved");
          this.modal.hide();
        },
        (error: any) => {
          this.loading = false;
          this.notificationService.warn("error", "Something went wrong");
        }
      );
  }

  closeMyModal(event, internal?: string) {
    if (internal) {
      document.querySelector("#" + event).classList.remove("md-show");
    } else {
      event.target.parentElement.parentElement.parentElement.classList.remove(
        "md-show"
      );
    }
  }
}
